(function () {
  "use strict";

  EditUserInfoSidebarCtrl.$inject = ['$scope', 'mtypes', 'usersResource', 'accountFeatures', 'textLengthIndicatorState', 'modalHelper'];
  angular
    .module('trainerWebApp.controllers')
    .controller('EditUserInfoSidebarCtrl', EditUserInfoSidebarCtrl);


  function EditUserInfoSidebarCtrl($scope, mtypes, usersResource, accountFeatures, textLengthIndicatorState, modalHelper) {

    var self = this; // for testing

    var textLengthLookup = {
      firstName: 35,
      lastName: 35,
      email: 254,
      username: 254,
      password: 35,
      roleName: 100 // Only needed to work in this validation scheme. The length of the role name doesn't actually matter.
    };

    var storedUserInfo = $scope.selectedUser;
    $scope.data = {
      firstName: $scope.selectedUser.firstName,
      id: $scope.selectedUser.id,
      lastName: $scope.selectedUser.lastName,
      email: $scope.selectedUser.email,
      permissions: $scope.selectedUser.permissions
    };

    var emailRegex = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
    var formFieldValidityCache = {};

    var fieldsToCheckAndApply = ['firstName', 'lastName', 'email', 'username', 'password', 'permissions'];

    if ($scope.isUsernameEnabled) {
      $scope.data.username = $scope.selectedUser.username;
      $scope.data.hasPassword = $scope.selectedUser.hasPassword;
    }

    _.each($scope.customUserFields, function (field) {
      var fieldName = 'customField' + field.fieldIndex;

      textLengthLookup[fieldName] = 200;

      $scope.data[fieldName] = $scope.selectedUser[fieldName];

      fieldsToCheckAndApply.push(fieldName);

      field.fieldName = fieldName;
      field.indicatorStyle = fieldName + 'IndicatorStyle';
      field.style = fieldName + 'Style';

      $scope[fieldName + 'IndicatorStyle'] = '';
      $scope[fieldName + 'IndicatorText'] = '';
      $scope[fieldName + 'Style'] = '';
    });

    var roles = [];

    if ($scope.selectedUser.isOwner) {
      $scope.data.role = mtypes.userRole.administrator;
      $scope.data.roleName = 'Administrator (Owner)';
      storedUserInfo.role = mtypes.userRole.administrator;
      storedUserInfo.roleName = 'Administrator (Owner)';
    }

    // Put roles in display order.
    var userRoles = [
      {
        name: 'Trainee',
        id: mtypes.userRole.trainee
      },
      {
        name: 'Reporter',
        id: mtypes.userRole.reporter
      },
      {
        name: 'Team Lead',
        id: mtypes.userRole.teamLead
      },
      {
        name: 'Manager',
        id: mtypes.userRole.manager
      },
      {
        name: 'Trainer',
        id: mtypes.userRole.trainer
      },
      {
        name: 'Administrator',
        id: mtypes.userRole.administrator
      }
    ];
    _.each(userRoles, function (userRole) {
      if (isRoleAllowedOnAccount(userRole.id)) {
        var role = {text: userRole.name, id: userRole.id};
        roles.push(role);

        if (!$scope.selectedUser.isOwner && $scope.selectedUser.permissions == userRole.id) {
          $scope.data.role = role;
          $scope.data.roleName = role.text;
          storedUserInfo.role = role;
          storedUserInfo.roleName = role.text;
        }
      }
    });

    $scope.selectRoleOptions = {
      width: 'off',
      data: roles,
      closeOnSelect: true,
      allowClear: false
    };

    $scope.serverCallInProgress = false;

    recalcFormTextLengthIndicators();
    clean();

    function isRoleAllowedOnAccount(role) {
      if (accountFeatures.features.indexOf(mtypes.featureEntry.trainerPermissions) != -1)
        return true;
      else
        return role == mtypes.userRole.administrator || role == mtypes.userRole.trainee;
    }

    $scope.getIndicatorStyle = function (name) {
      return $scope[name + 'IndicatorStyle'];
    };

    $scope.getIndicatorText = function (name) {
      return $scope[name + 'IndicatorText'];
    };

    $scope.getFieldStyle = function (name) {
      return $scope[name + 'Style'];
    };

    $scope.cancelChanges = function () {
      clean();
      $scope.changeSidebar('pages/users/userDetailsSidebar.html');
    };

    $scope.applyChanges = function () {
      var info = {};
      $scope.data.permissions = $scope.data.role.id;

      _.each(fieldsToCheckAndApply, function (field) {
        if (fieldChanged(field))
          info[field] = $scope.data[field];
      });

      if (info.password && info.password.length < 8) {
        modalHelper.messageBox({
          title: 'Error Updating User Info',
          message: 'Password must be a minimum of 8 characters'
        });
        return;
      }

      $scope.serverCallInProgress = true;
      usersResource.updateUserInfo(
        $scope.data.id,
        info,
        function (res) {
          clean();
          $scope.refreshSelectedUserInfo(function () {
            $scope.changeSidebar('pages/users/userDetailsSidebar.html');
          });
        },
        function (err) {
          $scope.serverCallInProgress = false;
          var message = 'There was an error updating the user\'s data. Please try again.';
          if (err && err.data)
            message = err.data;
          modalHelper.messageBox({title: 'Error Updating User Info', message: message, buttons: [{label: 'OK'}]});
        }
      );
    };

    $scope.canModifyUsersRole = function () {
      return $scope.canModifyRole && !storedUserInfo.isOwner &&
        storedUserInfo.status == mtypes.userStatus.active &&
        mfConfig.userId != storedUserInfo.id;
    };

    function fieldChanged(arg) {
      return $scope.data[arg] != storedUserInfo[arg];
    }

    function clean() {
      $scope.serverCallInProgress = false;
      $scope.manageUsersEditors.editUserInfoSidebarDirty = false;
      $scope.editUserInfoSidebarValid = true;
    }

    $scope.checkDirty = function () {
      $scope.data.roleName = $scope.data.role.text;
      recalcFormTextLengthIndicators();
      $scope.editUserInfoSidebarValid = calcFormValidity() && validateUserModel($scope.data);
      $scope.manageUsersEditors.editUserInfoSidebarDirty = calcFormDirty();
    };

    $scope.onDetailFormFieldFocus = function (key) {
      applyFormState(key, formFieldValidityCache[key]);
    };

    function applyFormState(key, state) {
      $scope[key + 'IndicatorStyle'] = state.style;
      $scope[key + 'IndicatorText'] = state.text;
      $scope[key + 'Style'] = state.dataValid ? '' : 'redBorder';
    }

    $scope.validateDetailFormTextLength = function (key) {
      doValidateFormTextLength(key);
      $scope.editUserInfoSidebarValid = calcFormValidity() && validateUserModel($scope.data);
      $scope.manageUsersEditors.editUserInfoSidebarDirty = calcFormDirty();
    };

    function validateUserModel(model) {
      // first and last are required
      if (!model.firstName || !model.lastName)
        return false;

      // email required for all non-trainees
      if (!isTrainee() && !model.email)
        return false;

      // trainees must have an email, or a username and a password
      if (isTrainee() && !(model.email || (model.username && (model.hasPassword || model.password))))
        return false;

      return true;
    }

    function calcFormValidity() {
      for (var key in formFieldValidityCache) {
        if (!formFieldValidityCache[key].lengthValid || !formFieldValidityCache[key].dataValid)
          return false;
      }
      return true;
    }

    function calcFormDirty() {
      for (var key in formFieldValidityCache) {
        var newValue = $scope.data[key];
        //console.log("newValue == '' && storedUserInfo[key]...  "+newValue, storedUserInfo[key]);
        if (newValue == '' && storedUserInfo[key] != '')
          return true;
        if (newValue && newValue.trim() != storedUserInfo[key])
          return true;
      }
      return false;
    }

    $scope.onDetailFormFieldInputBlur = function (key) {
      // leave errors
      var state = formFieldValidityCache[key];
      if (!state.lengthValid || !state.dataValid)
        return;
      state = textLengthIndicatorState.defaultState;
      applyFormState(key, state);
    };

    function recalcFormTextLengthIndicators() {
      for (var key in textLengthLookup) {
        doValidateFormTextLength(key);
      }
      $scope.editUserInfoSidebarValid = calcFormValidity();
    }

    function doValidateFormTextLength(key) {
      if (!key) return;
      var text = $scope.data[key];
      var state = {};

      if (key === 'email')
        state = getEmailState();
      else if (key === 'username')
        state = getUsernameState();
      else if (key === 'password')
        state = getPasswordState();
      else
        state = textLengthIndicatorState.getState(text, textLengthLookup[key]);

      applyFormState(key, state);
      formFieldValidityCache[key] = state;
    }

    $scope.canApplyChanges = function () {
      return $scope.editUserInfoSidebarValid &&
        $scope.manageUsersEditors.editUserInfoSidebarDirty && !$scope.serverCallInProgress;
      //console.log("$scope.editUserInfoSidebarValid $scope.manageUsersEditors.editUserInfoSidebarDirty, !$scope.serverCallInProgress="+$scope.editUserInfoSidebarValid, $scope.manageUsersEditors.editUserInfoSidebarDirty, !$scope.serverCallInProgress);
    };

    $scope.$emit("initPlaceholders");

    /**
     * Password, username and email rules
     */
    function getPasswordState() {
      var key = 'password';
      var passwordText = $scope.data[key];
      // initial load
      if (passwordText === undefined)
        return {lengthValid: true, dataValid: true};

      var state = textLengthIndicatorState.getState(passwordText, textLengthLookup[key]);

      if (traineeWithoutEmail() && valueMissing(key))
        return state;

      if (passwordText.length > 0)
        return state;

      return {lengthValid: true, dataValid: true};
    }

    function getUsernameState() {
      var key = 'username';
      var usernameText = $scope.data[key];
      // initial load
      if (usernameText === undefined)
        return {lengthValid: true, dataValid: true};

      var state = textLengthIndicatorState.getState(usernameText, textLengthLookup[key]);

      if (traineeWithoutEmail() && valueMissing(key))
        return state;

      if (!valueMissing(key) && usernameText.length > 0)
        return state;

      return {lengthValid: true, dataValid: true};
    }

    function getEmailState() {
      var key = 'email';
      var emailText = $scope.data[key];
      // initial load
      if (emailText === undefined)
        return {lengthValid: true, dataValid: true};

      // trainee with a username
      if (isTrainee() && !valueMissing('username'))
        return {lengthValid: true, dataValid: true};

      var state = textLengthIndicatorState.getState(emailText, textLengthLookup[key]);

      // email is required for non-trainees
      if (!isTrainee() && valueMissing('email'))
        return state;

      // email is required when a trainee lacks a username
      if (traineeWithoutUsername() && valueMissing('email'))
        return state;

      // test valid email regex
      if (!emailRegex.test(emailText)) {
        state.dataValid = false;
        return state;
      }

      return {lengthValid: true, dataValid: true};
    }

    function valueMissing(key) {
      return !$scope.data[key] || $scope.data[key].trim().length == 0;
    }

    function isTrainee() {
      return $scope.data.role.id == mtypes.userRole.trainee;
    }

    function traineeWithoutEmail() {
      return isTrainee() && valueMissing('email');
    }

    function traineeWithoutUsername() {
      return isTrainee() && valueMissing('username');
    }
  }

})();
